import { TransactionDetails } from '@shared/types/reservations';
import {
  formatCouponCodeForDetails,
  isCouponCodeTruncated,
} from '@shared/utils/couponCode';
import { centsToDollar } from '@shared/utils/currency';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './ReservationGuestSheetReceipt.scss';

export interface ReservationGuestSheetReceiptProps {
  transactionDetails: TransactionDetails;
  className?: string;
}

export const ReservationGuestSheetReceipt = ({
  transactionDetails,
  className,
}: ReservationGuestSheetReceiptProps) => {
  const transactionLineItems = transactionDetails.lineItems || [];
  const couponCode = transactionDetails.purchaseDiscount?.code ?? null;

  return (
    <section className={cx(styles.section, className)}>
      <h3 className={typography.h7_20}>
        <span>Receipt</span>
        <span>#{transactionDetails.receiptNumber}</span>
      </h3>
      <dl className={typography.h7}>
        {transactionDetails.refundAmount && (
          <div>
            <dt>Refund Amount</dt>
            <dd>{centsToDollar(transactionDetails.refundAmount)}</dd>
          </div>
        )}
        {transactionLineItems.map((item) => (
          <div key={item.id}>
            <dt>{item.name}</dt>
            <dd>{centsToDollar(item.pricePerUnit * item.quantity)}</dd>
          </div>
        ))}
        {transactionDetails.purchaseDiscount && (
          <div>
            <dt>Coupon code</dt>
            <dd>
              <span
                title={
                  isCouponCodeTruncated(couponCode)
                    ? (couponCode ?? undefined)
                    : undefined
                }
              >
                {formatCouponCodeForDetails(couponCode)}
              </span>
            </dd>
          </div>
        )}
        <div>
          <dt>Tax</dt>
          <dd>{centsToDollar(transactionDetails.tax)}</dd>
        </div>
        <div>
          <dt>Processing</dt>
          <dd>{centsToDollar(transactionDetails.fee)}</dd>
        </div>
        <div className={typography.h7_20}>
          <dt>
            <strong>Total</strong>
          </dt>
          <dd>
            <strong>{centsToDollar(transactionDetails.total)}</strong>
          </dd>
        </div>
      </dl>
    </section>
  );
};
